<div class="layout-footer">
    <button
        *ngFor="let button of buttons"
        class="p-link layout-footer-menu-button layout-footer-button"
        [class.active]="isActive(button.route)"
        (click)="button.action()">

        <img [src]="button.icon" [alt]="button.label" class="footer-icon">

    </button>
</div>
